import React from "react";
import * as Mui from "@mui/material";
import { Integration } from "model/integration";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

interface Props {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	agentLabel?: string;
	pageName: string;
	loading: boolean;
	error: boolean;
	expirationText: string;
}

export function FacebookModal({ open, onClose, integration, agentLabel, pageName, loading, error, expirationText }: Props) {
	return (
		<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
			<Mui.Grid container direction="column" spacing={2}>
				{agentLabel && (
					<Mui.Grid item>
						<Mui.Typography variant="body1"><strong>Connected User:</strong> {agentLabel}</Mui.Typography>
					</Mui.Grid>
				)}
				<Mui.Grid item>
					<Mui.Typography variant="body1">
						<strong>Facebook Page:</strong>{" "}
						{loading ? <Mui.CircularProgress size={16} /> : error ? <span style={{ color: "#f44336" }}>{pageName}</span> : pageName}
					</Mui.Typography>
				</Mui.Grid>
				{expirationText && (
					<Mui.Grid item>
						<Mui.Typography variant="body2" color="textSecondary">Token expires: {expirationText}</Mui.Typography>
					</Mui.Grid>
				)}
				<Mui.Grid item>
					<Mui.Typography variant="body2" color="textSecondary">
						This integration allows posting to your Facebook page from the mobile app.
					</Mui.Typography>
				</Mui.Grid>
			</Mui.Grid>
		</SimpleIntegrationModal>
	);
}
